import { Component } from "@builder.io/sdk";

export const faqsConfig: Component = {
  name: "FAQs",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "faqs",
      helperText: "Unique identifier for the section",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      helperText: "Heading for the FAQs section",
    },
    {
      name: "items",
      type: "list",
      subFields: [
        {
          name: "defaultOpen",
          type: "boolean",
          defaultValue: false,
          helperText: "Whether the FAQs item is open by default",
        },
        {
          name: "header",
          type: "string",
          friendlyName: "Question",
          helperText: "Question for the FAQs item",
          required: true,
        },
        {
          name: "content",
          type: "richText",
          friendlyName: "Answer",
          helperText: "Answer for the FAQs item",
          required: true,
        },
      ],
      defaultValue: [
        {
          header:
            "How do I know which level of Home Care is right for my loved one?",
          content:
            "Our compassionate specialists can conduct a free assessment to determine your loved one's needs and recommend the most appropriate services.",
        },
        {
          header: "What qualifications do your Home Caregivers have?",
          content:
            "All our caregivers are professionally trained, state-registered, and undergo rigorous background checks.",
        },
        {
          header:
            "Can you work with my loved one's doctor and other healthcare providers?",
          content:
            "Absolutely! Collaboration is key. We communicate and coordinate care plans with your loved one's healthcare team.",
        },
        {
          header: "Do you offer services in my area?",
          content: "We serve San Francisco and the surrounding Bay Area.",
        },
      ],
    },
  ],
};
